"use client"
import { useEffect } from "react";
 
export default function useInputIntent() {
  useEffect(() => {
    const bodyElement = document.body;
 
    const setInputAttributes = (type: "mouse" | "keyboard") => {
      bodyElement.setAttribute("data-whatinput", type);
      bodyElement.setAttribute("data-whatintent", type);
    };
 
    const handleMouseInput = () => setInputAttributes("mouse");
    const handleKeyboardInput = () => setInputAttributes("keyboard");
 
    // Attach persistent event listeners
    window.addEventListener("mousedown", handleMouseInput);
    window.addEventListener("keydown", handleKeyboardInput);
 
    return () => {
      window.removeEventListener("mousedown", handleMouseInput);
      window.removeEventListener("keydown", handleKeyboardInput);
    };
  }, []);
}